import * as React from "react";
import { SVGProps } from "react";

const Phantasma = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 95 86"
    {...props}
  >
    <style>
      {".st2,.st9{fill:#fff}.st9{opacity:.5;enable-background:new}"}
    </style>
    <path
      fill="#88c6de"
      d="M78.9 0H16C7.2 0 0 7.4 0 16.6v55.2c0 4.8 5.7 7.1 8.8 3.5 3.8-4.4 10.4-4.3 14.1.1l4.9 5.7c2 2.3 5.5 2.3 7.5 0l5.1-5.8c3.8-4.3 10.3-4.3 14.1 0l5.1 5.9c2 2.3 5.5 2.3 7.5 0l5.1-5.9c3.8-4.3 10.3-4.3 14.1 0l.1.1c3.1 3.6 8.8 1.3 8.8-3.5V16.6C94.9 7.4 87.8 0 78.9 0z"
    />
    <path
      fill="#6ca2cb"
      d="M78.9 3.3H16c-8.8 0-16 7.4-16 16.6v55.2c0 4.8 5.7 7.1 8.8 3.5 3.8-4.4 10.4-4.3 14.1.1l4.9 5.7c2 2.3 5.5 2.3 7.5 0l5.1-5.8c3.8-4.3 10.3-4.3 14.1 0l5.1 5.9c2 2.3 5.5 2.3 7.5 0l5.1-5.9c3.8-4.3 10.3-4.3 14.1 0l.1.1c3.1 3.6 8.8 1.3 8.8-3.5V19.9c-.3-9.2-7.4-16.6-16.3-16.6z"
    />
    <circle cx={29.4} cy={31.1} r={9.7} className="st2" />
    <circle cx={65.6} cy={31.1} r={9.7} className="st2" />
    <linearGradient
      id="SVGID_1_"
      x1={57.862}
      x2={73.247}
      y1={56.9}
      y2={56.9}
      gradientTransform="matrix(1 0 0 -1 0 88)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#1eaacc" />
      <stop offset={1} stopColor="#0584b9" />
    </linearGradient>
    <circle cx={65.6} cy={31.1} r={7.7} fill="url(#SVGID_1_)" opacity={0.5} />
    <linearGradient
      id="SVGID_2_"
      x1={59.444}
      x2={71.665}
      y1={56.9}
      y2={56.9}
      gradientTransform="matrix(1 0 0 -1 0 88)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#1eaacc" />
      <stop offset={1} stopColor="#0584b9" />
    </linearGradient>
    <circle cx={65.6} cy={31.1} r={6.1} fill="url(#SVGID_2_)" opacity={0.5} />
    <linearGradient
      id="SVGID_3_"
      x1={61.717}
      x2={69.392}
      y1={56.9}
      y2={56.9}
      gradientTransform="matrix(1 0 0 -1 0 88)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#1eaacc" />
      <stop offset={1} stopColor="#0584b9" />
    </linearGradient>
    <circle cx={65.6} cy={31.1} r={3.8} fill="url(#SVGID_3_)" opacity={0.5} />
    <linearGradient
      id="SVGID_4_"
      x1={21.683}
      x2={37.067}
      y1={56.9}
      y2={56.9}
      gradientTransform="matrix(1 0 0 -1 0 88)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#1eaacc" />
      <stop offset={1} stopColor="#0584b9" />
    </linearGradient>
    <circle cx={29.4} cy={31.1} r={7.7} fill="url(#SVGID_4_)" opacity={0.5} />
    <linearGradient
      id="SVGID_5_"
      x1={23.265}
      x2={35.486}
      y1={56.9}
      y2={56.9}
      gradientTransform="matrix(1 0 0 -1 0 88)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#1eaacc" />
      <stop offset={1} stopColor="#0584b9" />
    </linearGradient>
    <circle cx={29.4} cy={31.1} r={6.1} fill="url(#SVGID_5_)" opacity={0.5} />
    <linearGradient
      id="SVGID_6_"
      x1={25.538}
      x2={33.212}
      y1={56.9}
      y2={56.9}
      gradientTransform="matrix(1 0 0 -1 0 88)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#1eaacc" />
      <stop offset={1} stopColor="#0584b9" />
    </linearGradient>
    <circle cx={29.4} cy={31.1} r={3.8} fill="url(#SVGID_6_)" opacity={0.5} />
    <circle cx={34.2} cy={26} r={2.2} className="st9" />
    <circle cx={70.4} cy={26} r={2.2} className="st9" />
  </svg>
);

export default Phantasma;
